<div class="atn-ds-widget">
  <div class="atn-ds-widget__header">
    <div class="atn-ds-widget__title">
      {{ title }}
    </div>
    <div>
      <ng-content select="[centered]" />
    </div>
    <div class="atn-ds-widget__actions">
      <ng-content select="[selectors]" />
      <ng-content select="[actions]" />
    </div>
  </div>
  <div class="atn-ds-widget__content">
    <ng-content />
  </div>
  <div class="atn-ds-widget__footer">
    <ng-content select="[footer]" />
  </div>
</div>
